/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { AxiosResponse } from 'axios';
import { Cookie, PersonalData } from '../../../types/PersonalData';
import { useMisDatosStore } from '../context/MisDatos.context';
import { useAuthStore as useAuthStoreEroski } from '../../../store/AuthContext';
import { HostProvider } from '../../../utils/HostProvider';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import DataService from '../../../services/MisDatosService';
import useAPIError from '../../../hooks/useAPIError';
import { StorageHelper } from '../../../utils/StorageHelper';
import { TextHelper } from '../../../utils/TextHelper';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { CookieHelper } from '../../../utils/CookieHelper';
import { MisDatosHelper } from '../MisDatosHelper';

interface Props {
  userForm?: boolean;
  passForm?: boolean;
  setUserForm?: (userForm: boolean) => void;
  setPassForm?: (passForm: boolean) => void;
  accessEmail?: string;
  cargarData?: () => void;
  personalData: PersonalData;
}

const ServicioV2PForm: FC<Props> = (props) => {
  const { personalData, cargarData } = props;
  const dataUser = useAuthStoreEroski();
  const [codigo, setCodigo] = useState('' as string);
  const [recuerdame, setRecuerdame] = useState(0 as number);
  const [reenvioRealizado, setReenvioRealizado] = useState(false as boolean);
  const [emailContacto, setEmailContacto] = useState('' as string);
  const [cantSms, setCantSms] = useState<number>(0);
  const [titleError, setTitleError] = useState('' as string);
  const [messageError, setMessageError] = useState('' as string);
  const [errorType, setErrorType] = useState(0 as number);
  const [showError, setShowError] = useState(false);
  const [mostrarModalV2P, setMostrarModalV2P] = useState(true);
  const [textForModalCambioEmail, setTextForModalCambioEmail] = useState(
    '' as string,
  );
  const [emailContactoCambiado, setEmailContactoCambiado] = useState<boolean>(
    false,
  );
  const {
    showModalServicioV2PForm,
    hideModalContactEmailV2P,
    hideModalContactEmail,
  } = useMisDatosStore();
  const { t } = useTranslation();
  const { addError } = useAPIError();
  const isCaprabo = HostProvider.isCaprabo();
  const isApp = dataUser.user.isApp === 'true';
  const errorAcceptButtonText = t('entendido');
  const title = t('datos.personaldata.modal-email-confirmacion-title');
  const text1 = t('datos.personaldata.modal-email-confirmacion-message1');
  const text2 = t('datos.personaldata.modal-email-confirmacion-message2');
  const acceptButtonTextKey = t('entendido');
  const misDatosHelper = new MisDatosHelper();

  const {
    formState: { errors },
    register,
    handleSubmit,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
  });

  const linkContacto = isCaprabo
    ? `${process.env.REACT_APP_API_CAPRABO}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_CLUB_CAPRABO
      }atencion-cliente/&fromApp=${t('caprabo_com')}`
    : `${process.env.REACT_APP_API}/clienteLogado/getTK?fromUrl=${
        process.env.REACT_APP_SERVER_EROSKI_ES
      }${t('link.contacto')}&fromApp=${t('eroski_es')}`;

  const HandleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'codigo':
        setCodigo(e.target.value);
        setValue('inputCodigo', `${e.target.value}`);
        break;
      case 'confiar':
        setRecuerdame(e.target.checked ? 1 : 0);
        break;
    }
  };

  const acceptError = () => {
    setShowError(false);
    console.log(errorType);
  };

  const acceptEmailSend = () => {
    hideModalContactEmailV2P();
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {};

  useEffect(() => {
    const nuevoEmailContacto = StorageHelper.getNuevoEmailContacto() as string;
    if (nuevoEmailContacto !== null && nuevoEmailContacto !== undefined) {
      StorageHelper.removeNuevoEmailContacto();
      setEmailContacto(nuevoEmailContacto);
    }
  }, []);

  const gestionErrorUpdateDobleVerificacion = (
    response: AxiosResponse<any>,
  ) => {
    setTitleError(
      t(TextHelper.getErrorTitleKeyTransformed(response.data.title)),
    );
    setMessageError(
      t(TextHelper.getErrorMessageKeyTransformed(response.data.userMessage)),
    );
    setErrorType(response.data.errorCode);
    setShowError(true);
    if (
      response.data.errorCode ===
      ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_INCORRECT_PASSWORD_EXCEPTION
    ) {
      setCantSms(cantSms + 1);
    }
  };

  const crearCookieDobleVerificacion = (response: AxiosResponse<any>) => {
    const cookie = response.data.pojo as Cookie;
    if (cookie) {
      if (isCaprabo) {
        CookieHelper.setCookieValue(cookie.cookieName, cookie.cookieValue, {
          domain: '.caprabo.com',
          extricto: false,
        });
      } else {
        CookieHelper.setCookieValue(cookie.cookieName, cookie.cookieValue, {
          domain: '.eroski.es',
          extricto: false,
        });
      }
    }
  };

  const updateDatosAcceso = () => {
    const data = {
      tipo: 'AC',
      fromApp: isApp ? 'app_club' : 'web',
      codigo,
      dobleVerificacion: true,
      recuerdame,
      emailContacto: emailContacto,
      tipoCambioMail: 'CO',
      tipoUsuario: personalData.tipoUsuario,
      version: null,
    };
    DataService.updateEmailContactoV2P(data)
      .then((response) => {
        if (response.data.error === true) {
          if (response.data.errorCode === ErrorCodeConstants.SYSTEM_EXCEPTION) {
            setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
            setErrorType(response.data.errorCode);
            setShowError(true);
          } else {
            gestionErrorUpdateDobleVerificacion(response);
          }
        } else {
          crearCookieDobleVerificacion(response);
          setCodigo('');
          setTextForModalCambioEmail(t(text1) + t(text2));
          setEmailContactoCambiado(true);
          setMostrarModalV2P(false);
          hideModalContactEmail();
          if (typeof cargarData === 'function') {
            cargarData();
          }
        }
      })
      .catch((er: any) => {
        console.log(er);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
      });
  };

  const sendSMS = (isReenvio: boolean) => {
    const prefijo = misDatosHelper.setPrefijoTelefono(
      personalData.prefijoTelefono,
    );
    const data = {
      prefijo: prefijo,
      telefono: personalData.telefono,
      tipo: 'AC',
      fromApp: isApp ? 'app_club' : 'web',
      version: '',
      idDispositivo: '',
      longitud: '',
      latitud: '',
      mobileDevice: false,
      ip: '',
      flujo: 'CO-TV',
      email: getValues('emailContacto'),
    };
    if (data.prefijo && data.telefono) {
      DataService.sendSmsDobleVerif(data).then((response) => {
        if (response.data.error === true) {
          if (
            response.data.errorCode ===
            ErrorCodeConstants.SEND_SMS_DATOSACCESO_NUMERO_TEMPORAL_EXISTE_EXCEPTION
          ) {
            console.log(response.data.errorCode);
          }
          if (
            response.data.errorCode ===
            ErrorCodeConstants.SEND_SMS_DATOSACCESO_NUMERO_EXISTE_EXCEPTION
          ) {
            console.log(response.data.errorCode);
          } else if (
            response.data.error &&
            response.data.errorCode !==
              ErrorCodeConstants.SEND_SMS_DATOSACCESO_NUMERO_TEMPORAL_EXISTE_EXCEPTION
          ) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
          }
        } else if (isReenvio) {
          setReenvioRealizado(true);
        } else {
          setReenvioRealizado(false);
        }
      });
    }
  };

  return (
    <>
      {(() => {
        if (mostrarModalV2P) {
          return (
            <>
              // eslint-disable-next-line no-unused-expressions
              <div
                className={`modal modal--small ${
                  showModalServicioV2PForm ? 'is-active' : ''
                }`}
                id="modal-sms"
              >
                <div className="modal__background" />
                <div className="modal__card u-text-center">
                  <header className="modal__card-head u-flex">
                    <div className="modal__card-title">
                      {' '}
                      {t('datos.accessdata.verificar-telf')}
                    </div>
                  </header>
                  <div className="modal__card-body">
                    <form
                      id="form-datos-movil-verificar"
                      className="form-datos"
                      onSubmit={handleSubmit(() => {
                        updateDatosAcceso();
                      })}
                    >
                      <fieldset>
                        <div className="form-group select-wrapper u-margin-bottom">
                          <label className="control-label u-text-left u-full-width u-margin-bottom">
                            {t('datos.accessdata.sms-sended-email-contact')}
                          </label>
                          <div className="form-control-block u-margin-bottom">
                            <input
                              type="text"
                              className={`form-control ${
                                errors.inputCodigo ? 'error' : ''
                              }`}
                              id="tfn2-sms"
                              maxLength={5}
                              {...register('inputCodigo', {
                                required: true,
                                pattern: /^[0-9]+$/i,
                                minLength: 5,
                              })}
                              onChange={(e) => HandleChange(e, 'codigo')}
                            />
                            {errors.inputCodigo &&
                              errors.inputCodigo.type === 'required' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="tfn2-sms-error"
                                  className="error"
                                  htmlFor="tfn2-sms"
                                >
                                  {t('validaciones.empty-value')}
                                </label>
                              )}
                            {errors.inputCodigo &&
                              errors.inputCodigo.type === 'pattern' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="tfn2-sms-error"
                                  className="error"
                                  htmlFor="tfn2-sms"
                                >
                                  {t('validaciones.not-valid-value')}
                                </label>
                              )}
                            {errors.inputCodigo &&
                              errors.inputCodigo.type === 'minLength' && (
                                // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                <label
                                  id="tfn2-sms-error"
                                  className="error"
                                  htmlFor="tfn2-sms"
                                >
                                  {t('validaciones.not-valid-code')}
                                </label>
                              )}
                          </div>
                          <div className="form-group u-margin-bottom u-text-left">
                            <label className="checkgroup" htmlFor="confiar">
                              {t('datos.accessdata.trust-browser')}

                              <input
                                type="checkbox"
                                id="confiar"
                                onChange={(e) => HandleChange(e, 'confiar')}
                              />
                              <span className="checkmark" />
                            </label>
                          </div>
                          {!reenvioRealizado ? (
                            <p className="u-margin-bottom u-text-left">
                              {t('datos.accessdata.not-sms-received')}{' '}
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a
                                href="#"
                                className="link u-display-inline"
                                onClick={() => sendSMS(true)}
                              >
                                {t('datos.accessdata.re-send')}
                              </a>
                            </p>
                          ) : (
                            <p className="u-margin-bottom u-text-left">
                              {t('datos.accessdata.re-sended-part1')}{' '}
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a
                                href={linkContacto}
                                className="link u-display-inline"
                              >
                                {t('datos.accessdata.re-sended-url')}
                              </a>{' '}
                              {t('datos.accessdata.re-sended-part2')}
                            </p>
                          )}
                          <div className="modal__botonera">
                            <button
                              id="accept-btn"
                              type="submit"
                              className="btn btn-primary u-margin-bottom"
                            >
                              {t('datos.accessdata.accept')}
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </>
          );
        }
        return '';
      })()}
      <ModalConfirmacion
        isBig={false}
        isSmall={false}
        textCentered
        showModal={emailContactoCambiado}
        setShowModal={setEmailContactoCambiado}
        title={t(title)}
        textHTMLContent={textForModalCambioEmail}
        doClose={acceptEmailSend}
        doAceptar={acceptEmailSend}
        showCancel={false}
        acceptButtonTextKey={acceptButtonTextKey}
      />
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showError}
        setShowModal={setShowError}
        title={t(titleError)}
        textHTMLContent={t(messageError)}
        doAceptar={acceptError}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={errorAcceptButtonText}
      />
    </>
  );
};

export default ServicioV2PForm;
